export default __webpack_public_path__ + "static/logo2-light-4e69b9ed481a45dff6b15516130670ee.png";